import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlugin1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconPlugin1"><Path d="M9 2.5C9 2.22386 8.77614 2 8.5 2C8.22386 2 8 2.22386 8 2.5L8 6H6.5C5.11929 6 4 7.11929 4 8.5V14.5C4 16.9853 6.01472 19 8.5 19H11.5V21.5C11.5 21.7761 11.7239 22 12 22C12.2761 22 12.5 21.7761 12.5 21.5V19H15.5C17.9853 19 20 16.9853 20 14.5L20 8.5C20 7.11929 18.8807 6 17.5 6H16L16 2.5C16 2.22386 15.7761 2 15.5 2C15.2239 2 15 2.22386 15 2.5L15 6H9L9 2.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPlugin1;
